var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"media-icon-wrap",style:(_vm.wrapStyle)},[_c('img',{attrs:{"src":_vm.url,"alt":"icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }